import { Box, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import { QuickRangeKey } from '../hooks/dateRanges'


type Props = {
  t: (k: string) => string
  quickRange: QuickRangeKey
  onQuickRangeChange: (v: QuickRangeKey) => void
  startDate: string
  endDate: string
  onStartChange: (v: string) => void
  onEndChange: (v: string) => void
}

export default function DateRangeFilter({
  t, quickRange, onQuickRangeChange, startDate, endDate, onStartChange, onEndChange
}: Props) {
  const showCustom = quickRange === 'custom'

  return (
    <Box display="flex" gap={2} mb={3} flexWrap="wrap" alignItems="center">
      <FormControl sx={{ minWidth: 260 }}>
        <InputLabel id="quick-range-label">{t('filter-by-date')}</InputLabel>
        <Select
          labelId="quick-range-label"
          label={t('filter-by-date')}
          value={quickRange}
          onChange={(e) => onQuickRangeChange(e.target.value as QuickRangeKey)}
        >
          <MenuItem value="today">{t('Today')}</MenuItem>
          <MenuItem value="yesterday">{t('yesterday')}</MenuItem>

          <MenuItem value="this_week">{t('this-week')}</MenuItem>
          <MenuItem value="past_week">{t('past-week')}</MenuItem>

          <MenuItem value="last_7">{t('last-7-days')}</MenuItem>
          <MenuItem value="last_30">{t('last-30-days')}</MenuItem>
          <MenuItem value="last_90">{t('last-90-days')}</MenuItem>

          <MenuItem value="this_month">{t('this-month')}</MenuItem>
          <MenuItem value="past_month">{t('past-month')}</MenuItem>

          <MenuItem value="this_year">{t('this-year')}</MenuItem>
          <MenuItem value="past_year">{t('past-year')}</MenuItem>

          <MenuItem value="custom">{t('custom')}</MenuItem>
        </Select>
      </FormControl>

      {showCustom && (
        <>
          <TextField
            type="date"
            label={t('start-date') || 'Fecha inicio'}
            InputLabelProps={{ shrink: true }}
            value={startDate}
            onChange={(e) => onStartChange(e.target.value)}
          />
          <TextField
            type="date"
            label={t('end-date') || 'Fecha fin'}
            InputLabelProps={{ shrink: true }}
            value={endDate}
            onChange={(e) => onEndChange(e.target.value)}
          />
        </>
      )}
    </Box>
  )
}
